import React, { useEffect, useState } from 'react';
import TimeKeeper from 'react-timekeeper';
import './index.scss';
import { convertFrom24To12HrFormat } from 'utils';

const TimePicker = props => {
  const [time, setTime] = useState<any>('00:00');
  const [showPicker, setShowPicker] = useState<boolean>(false);
  const { value, onChange, options, hourFormat24 } = props;
  useEffect(() => {
    setTime(value);
  }, []);

  const onChangeTime = (time: {
    formatted12: string;
    formattedSimple: string;
    formatted24: string;
    hour: number;
    hour12: number;
    minute: number;
    meridiem: string;
  }) => {
    let { hour, minute }: Record<string, string | number> = time;
    if (hourFormat24) {
      setTime(hour);
    }
    else {
      hour = hour.toString();
      minute = minute.toString();
      if (hour.length === 1) {
        hour = `0${hour}`;
      }
      if (minute.length === 1) {
        minute = `0${minute}`;
      }
      setTime(`${hour}:${minute}`);
    }
  };

  const getDisplayValue = (value: any) => convertFrom24To12HrFormat(hourFormat24 ? value.toString() : value, true);

  return (
    <div className={'time-picker-container'}>
      {/* {showPicker ? ( */}
      {showPicker && (
        <TimeKeeper
          time={time}
          onChange={onChangeTime}
          onDoneClick={() => {
            onChange(time);
            setShowPicker(false);
          }}
          switchToMinuteOnHourSelect={true}
          {...options}
        />
      )}
      <input
        readOnly
        className={'time-picker-input'}
        value={getDisplayValue(value)}
        onClick={() => setShowPicker(true)}
      />
      {/* )} */}
    </div>
  );
};

export default TimePicker;